import React, { useEffect, useState } from "react";
import dataProvider from "../../../providers/dataProvider";
import { Boost } from "../../../types/boost";
import { Box, Card, TextField } from "@material-ui/core";
import CreateContentField from "./CreateContentField";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";

import "./style.css";

interface BoostError {
  orderCost?: string;
  boostDiscount?: string;
}

const OrdersBoostTab = () => {
  const [stateBoost, setStateBoost] = useState<Array<Boost>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<BoostError[]>([]);
  const [generalId, setGeneralId] = useState(undefined);

  useEffect(() => {
    setBoostsToState();
  }, []);

  const setBoostsToState = async () => {
    const general = await getGeneral();
    console.log(general);
    
    if (general && general.ordersBoost) {
      setStateBoost(general.ordersBoost);
      setGeneralId(general._id)
    }
  };

  const getGeneral = async () => {
    const result = await dataProvider.getGeneral();
    return result.data;
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number,
    field: keyof Boost
  ) => {
    const { value } = e.target;
    setStateBoost((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]:
          field === "orderCost" ||
          field === "boostCost" ||
          field === "boostTickets"
            ? Number(value)
            : value,
      };
      return updated;
    });
  };

  const handleAddBoost = () => {
    const updated = [...stateBoost];
    updated.push({
      orderCost: 1,
      boostCost: 0,
      boostTickets: 0,
      boostDiscount: "0%",
    });
    setStateBoost(updated);
  };

  const handleRemoveBoost = (i: number) => {
    const updated = [...stateBoost];
    updated.splice(i, 1);
    setStateBoost(updated);
  };

  const boostValidate = () => {
    const newErrors: BoostError[] = [];

    stateBoost.forEach((boost, i) => {
      const err: BoostError = {};

      if (!boost.boostDiscount.trim()) {
        err.boostDiscount = "Discount value is required";
      }

      if (boost.orderCost === 0) {
        err.orderCost = "Order cost cannot be 0";
      }

      const duplicates = stateBoost.filter(
        (b, idx) => b.orderCost === boost.orderCost && idx !== i
      );
      if (duplicates.length > 0) {
        err.orderCost = "Order cost must be unique";
      }

      newErrors.push(err);
    });
    setErrors(newErrors);
    return newErrors.every((e) => Object.keys(e).length === 0);
  };

  const handleSave = async () => {
    if (boostValidate()) {
      const result = await dataProvider.updateGeneral({
        id: generalId,
        data: {ordersBoost: [...stateBoost]},
      });
    }
  };

  return (
    <Card component="div" className="tabCardWrapper orders-boost">
      <h3 className="orders-boost__title">Orders Boost:</h3>
      <div className="orders-boost__content">
        {stateBoost.map((boost, i) => {
          return (
            <div className="content__fields-item" key={i}>
              <div className="content__fields-row">
                <CreateContentField
                  fieldTitle="order cost, £:"
                  field={
                    <Box>
                      <TextField
                        label=""
                        size="small"
                        variant="outlined"
                        type="number"
                        error={!!errors[i]?.orderCost}
                        helperText={errors[i]?.orderCost}
                        onChange={(e) => handleChange(e, i, "orderCost")}
                        value={boost.orderCost}
                        inputProps={{ min: 0 }}
                      />
                    </Box>
                  }
                />
                <CreateContentField
                  fieldTitle="boost cost, £:"
                  field={
                    <Box>
                      <TextField
                        label=""
                        size="small"
                        variant="outlined"
                        type="number"
                        onChange={(e) => handleChange(e, i, "boostCost")}
                        value={boost.boostCost}
                        inputProps={{ min: 0 }}
                      />
                    </Box>
                  }
                />
                <CreateContentField
                  fieldTitle="boost tickets:"
                  field={
                    <Box>
                      <TextField
                        label=""
                        size="small"
                        variant="outlined"
                        type="number"
                        onChange={(e) => handleChange(e, i, "boostTickets")}
                        value={boost.boostTickets}
                        inputProps={{ min: 0 }}
                      />
                    </Box>
                  }
                />
                <CreateContentField
                  fieldTitle="boost discount:"
                  field={
                    <Box>
                      <TextField
                      
                        label=""
                        size="small"
                        variant="outlined"
                        type="text"
                        error={!!errors[i]?.boostDiscount}
                        helperText={errors[i]?.boostDiscount}
                        onChange={(e) => handleChange(e, i, "boostDiscount")}
                        value={boost.boostDiscount}
                      />
                    </Box>
                  }
                />
                <button
                  className="content__delete-btn"
                  type="button"
                  onClick={() => handleRemoveBoost(i)}
                >
                  <RemoveIcon />
                </button>
              </div>
            </div>
          );
        })}
        <button
          className="content__add-btn"
          type="button"
          onClick={handleAddBoost}
        >
          <AddIcon />
        </button>
      </div>
      <button
        className="content__save-btn"
        type="button"
        disabled={isLoading}
        onClick={handleSave}
      >
        Save
      </button>
    </Card>
  );
};

export default OrdersBoostTab;
